const r = () => {
};
function a(v, e) {
  return v.provide("dsOverlay", {
    onOverlayActive: e.onOverlayActive || r,
    onOverlayInactive: e.onOverlayInactive || r
  });
}
export {
  a as default
};
//# sourceMappingURL=design-system.es23.js.map
